const openLicence = (state) => (newLicence) => {
  const { openLicences = [] } = state;
  const { licenceId: targetLicenceId } = newLicence;
  if (!targetLicenceId) return state; // bail if no new licenceId supplied
  if (!openLicences.some(({ licenceId }) => licenceId === targetLicenceId))
    return {
      ...state,
      openLicences: [...openLicences, newLicence],
    };
  return state; // bail if licence already open
};

export default openLicence;
